import { OohCourierVisit } from '../graphql/types';
import { useOohVisitsQuery } from '../graphql/Routes/OohVisits.generated';

type OohVisitsResult = {
  areOohVisitsLoading: boolean;
  oohVisits: OohCourierVisit[];
};

const useOohVisitsDataStore = (
  date: string | null,
  oohId: string | null,
): OohVisitsResult => {
  const { loading, data } = useOohVisitsQuery({
    skip: !oohId || !date,
    variables:
      oohId && date
        ? {
            date,
            oohId,
          }
        : undefined,
  });

  if (date !== undefined) {
    return {
      oohVisits: data?.OohVisits!,
      areOohVisitsLoading: loading,
    };
  }

  return {
    oohVisits: [],
    areOohVisitsLoading: false,
  };
};
export default useOohVisitsDataStore;
